import { DateRange } from './date';
import {Merchants} from './merchant';

export class Location {
    id: number;
    code: number;
    name: number;
    merchant: Merchants;
    createdDate: string;
    updatedBy: number;
    updatedDate: string;
}

export class LocationSearch {
    createdDate: DateRange = DateRange.empty();
    todayDate: DateRange = DateRange.today()
    name = '';
    code = '';
    lId = '';
    merchant = '';
    field: 'name' | 'code' = 'name';
    value: '';
    status = 'All';
    appCode = '';
    productId = '';
 }

